var Customizing = require("../Customizing");
var Type        = require("./Type");

/**
 * The Timezone class represents a data type similar to
 * Enumeration but refers to the timezone customizing.
 *
 * @param {Object} [oConfig] Configuration object for this type
 * @constructor
 */
function Timezone(oConfig) {
	Type.call(this, oConfig);
}

Timezone.prototype = Object.create(Type.prototype);
Timezone.prototype.constructor = Timezone;

/**
 * Returns the mapped value for the key that is present in the
 * business object. If no translation is available for the given key,
 * the key is returned.
 *
 * @param {string} sProperty Name of the property that contains the key
 * @param {Object} oData Business object that contains the data
 * @returns {string} The value of the given property after type specific processing
 * @protected
 */
Timezone.prototype.getValue = function(sProperty, oData) {
	const sKey = oData[sProperty];

	return Customizing.getTimezoneTranslation(sKey);
};

module.exports = Timezone;